/* global $:false */

import 'jquery-ui/sortable.js'

export default class TopbarContentBlockSlugs {
  static init () {
    this.el = $('#topbar-content-blocks')
    if (!(this.el.length > 0)) { return }
    $('#topbar-content-block-slugs').sortable()

    this.contentBlocks = this.el.find('#topbar-content-block-slugs')
    this.updateUrl = this.el.data('update-url')

    this.contentBlocks.on('sortupdate', (e, ui) => {
      this.updateBlocks()
    })
  }

  static updateBlocks () {
    $.ajax(
      this.updateUrl, {
        type: 'PUT',
        dataType: 'json',
        data: { topbar_content_block_slugs: $('#topbar-content-block-slugs').sortable('toArray', { attribute: 'data-slug' }) },
        success: data => {
          $('#preview').load(window.location + ' #preview')
        }
      }
    )
  }
}
